<template>
    <div class="column email-card">
        
        <nav class="level">
            <div class="level-left">

                <div class="level-item has-text-centered" style="margin-left: 32px">
                    <div>
                        <p class="heading">BransjeID</p>
                        <p class="title is-4">{{ branch.branchId }}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Firma</p>
                        <p class="title is-4">{{ branch.branchName }}</p>
                    </div>
                </div>
                
            </div>
            <div class="level-right">
                <!-- <div class="level-item has-text-centered">
                    <div>
                        <a class="button is-danger" @click="confirmDeleteBranch(branch)">
                            <b-icon pack="fa" icon="trash"></b-icon>
                            <span>Slett {{ branch.name }}</span>
                        </a>
                    </div>
                </div> -->
            </div>
        </nav>

        <div class="box">
            <b-table
                :data="branch.emailSettingRows"
                :hoverable="true">

                <template slot-scope="props">

                    <b-table-column label="Rapporttype">
                        {{ namedReportType(props.row.reportType).name }}
                    </b-table-column>

                    <b-table-column label="Sendes til">
                        <span v-for="(receiver, index) in props.row.emailReceivers" v-bind:key="index">
                            <b-tooltip label="Send epostrapport nå">
                                <button @click="sendEmailReport(props.row, receiver)" class="button is-text"><span>{{ receiver }}</span> <b-icon icon="envelope"></b-icon></button>
                            </b-tooltip><br />
                        </span>
                    </b-table-column>

                    <b-table-column label="Baxnumre">
                        <span v-if="props.row.allBax">Alle baxnumre</span>
                        <ul v-if="!props.row.allBax">
                            <li v-for="(bax, index) in props.row.baxNumbers" v-bind:key="index">
                                {{ bax }}
                            </li>
                        </ul>
                    </b-table-column>

                    <b-table-column label="Type rapport">
                        {{ namedExportFormat(props.row.exportFormat).name }}
                    </b-table-column>

                    <b-table-column numeric>
                        <b-tooltip label="Rediger rapportutsendelse">
                            <a class="button is-primary" @click="editEmailItem(props.row)">
                                <b-icon pack="fa" icon="edit"></b-icon>
                            </a>
                        </b-tooltip> 

                        <b-tooltip type="is-danger" label="Slett rapportutsendelse" style="margin-left: 8px">
                            <a class="button is-danger" @click="confirmDelete(props.row)">
                                <b-icon pack="fa" icon="trash"></b-icon>
                            </a> 
                        </b-tooltip>
                    </b-table-column>

                </template>

                <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                pack="fa"
                                icon="recycle"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Ingen epostregler definert. Kom igang med å benytte knappen 'Ny mottaker' nedenfor.</p>
                    </div>
                </section>
            </template>

            </b-table>

            <a class="button is-primary" style="margin-top: 16px" @click="newEmailItem()">
                <b-icon pack="fa" icon="plus"></b-icon>
                <span>Ny mottaker</span>
            </a>           

        </div>

        <div class="is-divider" style="margin-top: 48px; margin-bottom: 16px"></div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EmailModal from '@/components/email/EmailModal.vue'
import SendEmailReportModal from '@/components/email/SendEmailReportModal.vue'

export default {
    props: ['branch'],
    computed: {
        ...mapGetters('reporttypes', ['reportTypes']),
        ...mapGetters('emailreports', ['exportFormats'])        
    },
    methods: {
        ...mapActions('emailreports', ['deleteEmailSetting']),
        namedReportType (reportType) {
            return this.reportTypes[reportType] || {name: reportType}
        },
        namedExportFormat (exportFormat) {
            return this.exportFormats[exportFormat] || {name: exportFormat}
        },
        newEmailItem() {
            const item = {
                allBax: true,
                branchId: this.branch.branchId,
                emailReceivers: [],
                exportFormat: undefined,
                reportType: undefined,
                baxNumbers: undefined
            }

            this.launchModal(item)
        },
        editEmailItem (item) {
            this.launchModal(item)
        },
        launchModal (item) {
            this.$buefy.modal.open({
                parent: this,
                component: EmailModal,
                hasModalCard: true,
                props: {emailItem: item}, 
            }) 
        },
        confirmDelete (emailItem) {
            this.$buefy.dialog.confirm({
                title: 'Slette automatisert epostutsendelse',
                message: 'Er du sikker på at du ønsker å <b>slette</b> valgt epostutsendelse?',
                confirmText: 'Slett',
                cancelText: 'Avbryt',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => this.deleteConfirmAction(emailItem)
            })
        },
        async deleteConfirmAction (emailItem) {
            try {
                await this.deleteEmailSetting(emailItem)
                this.$buefy.toast.open({
                    message: 'Epostutsendelsen ble slettet',
                    type: 'is-success',
                    position: 'is-bottom'
                })
            }
            catch (error) {
                this.$buefy.toast.open({
                    message: 'En feil oppstod under sletting av automatisert epostutsendelse',
                    type: 'is-danger',
                    position: 'is-bottom'
                })
            }
        },
        sendEmailReport (emailItem, receiver) {
            this.$buefy.modal.open({
                parent: this,
                component: SendEmailReportModal,
                hasModalCard: true,
                props: {emailItem: emailItem, receiver: receiver}, 
            }) 
        }
    }
}
</script>
